module.exports = __webpack_public_path__ + "./images/2.8bd5381b4d3ed7b8c3894e5587dc04e9.png";